import theme from "../../theme";

export const style = {
  SECTION: {
    background: theme.foregroundColor,
  },
  SECTION_INNER: {
    margin: "0 auto",
    mobile: {
      desktop: {
        padding: 50,
      },
      smartphone: {
        padding: 10,
      },
    },
  },
  HEADLINE: {
    textAlign: "center",
    fontFamily: theme.fontFamily,
    fontWeight: "bold" as "bold",
    color: "#333",
    mobile: {
      desktop: {
        fontSize: 48,
        lineHeight: "55px",
      },
      smartphone: {
        fontSize: 42,
        lineHeight: "45px",
      },
    },
  },
  TEXT: {
    textAlign: "center",
    padding: 20,
    fontFamily: theme.fontFamily,
  },
  VIDEO: {
    maxWidth: 500,
    margin: "0 auto",
    padding: "100px 20px",
    backgroundColor: theme.backgroundColor,
    position: "relative",
  },
  BUTTON: {
    style: {
      display: "inline-block",
      padding: 10,
      border: "none",
      backgroundColor: theme.backgroundColor,
      marginTop: 20,
      minWidth: 100,
      borderRadius: 3,
      cursor: "pointer",
    },
    caption1: {
      color: theme.foregroundColor,
      fontWeight: "bold" as "bold",
      fontSize: "10pt",
    },
  },
};
